import React from 'react';
import { ArrowRight } from 'lucide-react';
import { heroContent, siteInfo } from '../data/mockData';

const HeroSection = ({ onCtaClick }) => {
  return (
    <>
      <section className="hero-section">
        <div
          className="hero-background"
          style={{ backgroundImage: `url(${siteInfo.heroImageUrl})` }}
        />
        <div className="hero-overlay" />
        <div className="hero-content">
          <h1 className="hero-title">
            {heroContent.title.split('\n').map((line, i) => (
              <React.Fragment key={i}>
                {line}
                {i < heroContent.title.split('\n').length - 1 && <br />}
              </React.Fragment>
            ))}
          </h1>
          <p className="hero-subtitle">
            {heroContent.subtitle.split('\n').map((line, i) => (
              <React.Fragment key={i}>
                {line}
                {i < heroContent.subtitle.split('\n').length - 1 && <br />}
              </React.Fragment>
            ))}
          </p>
          <button className="hero-cta" onClick={onCtaClick}>
            <span>{heroContent.ctaText}</span>
            <ArrowRight size={20} />
          </button>
        </div>
      </section>
      <div className="red-divider" />
    </>
  );
};

export default HeroSection;
